import React from 'react';
import { motion } from 'framer-motion';
import { Target, Clock, Zap, User, ShieldCheck, CheckCircle2 } from 'lucide-react';
const benefits = [{
  icon: Target,
  title: 'CLARIDAD',
  description: 'Identifica tu nivel de juego actual y define con precisión qué quieres que pase en 2026.',
  benefit: 'Dejas de perder energía en objetivos difusos y empiezas a jugar con dirección.'
}, {
  icon: Clock,
  title: 'FUGAS',
  description: 'Detecta y elimina las fugas de tiempo, energía y foco que hoy frenan tu avance (y el de tu equipo).',
  benefit: 'Más tiempo, más energía y más claridad sin trabajar más horas.'
}, {
  icon: Zap,
  title: 'FOCO 20%',
  description: 'Diseña tu plan desde el 20% que realmente mueve resultados, no desde más esfuerzo.',
  benefit: 'Resultados más rápidos y sostenibles, sin desgaste innecesario.'
}, {
  icon: User,
  title: 'IDENTIDAD',
  description: 'Alinea tu rol, tu identidad y tu visión para que accionar deje de sentirse pesado.',
  benefit: 'Accionas con más seguridad y menos esfuerzo emocional.'
}, {
  icon: ShieldCheck,
  title: 'SISTEMAS',
  description: 'Crea sistemas simples que blinden tu avance y te permitan liderar sin cargarlo todo tú.',
  benefit: 'Crecimiento real, replicable y sostenible, sin vivir apagando fuegos.'
}];
export function BenefitsSection() {
  return <section className="py-24 bg-slate-50 text-slate-900" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4" data-id="element-3">
        <div className="text-center mb-16" data-id="element-4">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-5">
            Qué es este <span className="text-amber-600" data-id="element-6">Entrenamiento</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-7">
            Juega desde Otro Nivel es un entrenamiento online, práctico y
            confrontativo donde vas a conseguir:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-8">
          {benefits.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 border border-slate-200 hover:border-amber-400 hover:shadow-lg transition-all group" data-id="element-9">
              <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors" data-id="element-10">
                <item.icon className="w-6 h-6 text-amber-600" data-id="element-11" />
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-12">
                {item.title}
              </h3>

              <p className="text-slate-700 mb-6 leading-relaxed" data-id="element-13">
                {item.description}
              </p>

              <div className="pt-6 border-t border-slate-200" data-id="element-14">
                <p className="text-sm font-semibold text-amber-600 mb-2 uppercase tracking-wider" data-id="element-15">
                  ¿En qué te beneficia?
                </p>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-16">
                  {item.benefit}
                </p>
              </div>
            </motion.div>)}

          {/* Last card is a summary/CTA card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl p-8 flex flex-col justify-center items-center text-center shadow-xl" data-id="element-17">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-18">
              No se trata de hacer más.
            </h3>
            <p className="text-white/95 text-lg mb-8" data-id="element-19">
              Se trata de jugar mejor. Y eso es exactamente lo que vas a
              aprender aquí.
            </p>
            <CheckCircle2 className="w-16 h-16 text-white/30 mb-4" data-id="element-20" />
          </motion.div>
        </div>
      </div>
    </section>;
}